import { createAction } from "@reduxjs/toolkit";
import { RESET_USER } from "./actionTypes";

export const resetUser = createAction(RESET_USER);
